import DIApi from './_diApi';

class EmployeeTypeAPI extends DIApi {
  controllerName = 'EmployeeTypes';
}

export default new EmployeeTypeAPI();
